/*global angular */
/*global Image */
/*global FileReader */
/*global navigator */
/*global document */
/*jslint node: true */
'use strict';

var image = angular.module('image', []);
image.directive('imageSlot', ['$templateCache', '$http', '$window', 'messages', 'msAuth', 'UploadQueue',
    function ($templateCache, $http, $window, messages, msAuth, UploadQueue) {
        var s;

        // upload
        function isUploadSupported() {
            if (navigator.userAgent.match(/(Android (1.0|1.1|1.5|1.6|2.0|2.1))|(Windows Phone (OS 7|8.0))|(XBLWP)|(ZuneWP)|(w(eb)?OSBrowser)|(webOS)|(Kindle\/(1.0|2.0|2.5|3.0))/)) {
                return false;
            }
            var elem = $window.document.createElement('input');
            elem.type = 'file';
            return !elem.disabled;
        }

        function updatePreview(dataURL) {
            s.slot.content = dataURL;
        }

        function readFile(file) {
            var reader = new FileReader();

            reader.onloadend = function () {
                processFile(reader.result, file.type);
            };

            reader.onerror = function () {
                console.log('There was an error reading the file!');
            };

            reader.readAsDataURL(file);
        }

        function processFile(dataURL, fileType) {
            var maxWidth = 1200; // section width TODO: replaced hardcoded value
            var maxHeight = 1800; // maxWidth*1.5

            var image = new Image();
            image.src = dataURL;

            image.onload = function () {
                var width = image.width, height = image.height;
                var shouldResize = (width > maxWidth) || (height > maxHeight);

                if (shouldResize) {
                    var newWidth, newHeight;

                    if (width > height) {
                        newHeight = height * (maxWidth / width);
                        newWidth = maxWidth;
                    } else {
                        newWidth = width * (maxHeight / height);
                        newHeight = maxHeight;
                    }

                    var canvas = $window.document.createElement('canvas');
                    canvas.width = newWidth;
                    canvas.height = newHeight;
                    var context = canvas.getContext('2d');

                    context.drawImage(this, 0, 0, newWidth, newHeight);

                    dataURL = canvas.toDataURL(fileType);
                    canvas = null;
                }

                updatePreview(dataURL);
                sendFile(dataURL);
            };

            image.onerror = function () {
                // todo: handle error console.log('There was an error processing your file!');
            };
        }

        function sendFile(fileData) {
            var imageSlot = s.slot;
            s.$root.$broadcast('msImageSlotUploadingStarted');
            imageSlot.uploading = true;
            imageSlot.settings.queue_id = UploadQueue.addUpload(fileData, imageSlot.settings, 'queue_id', imageSlot, 'content');
        }


        // rotate
        function rotateImage(degrees) {
            var image = $window.document.getElementById('image');
            var canvas = $window.document.getElementById('canvas');

            var context = canvas.getContext('2d');

            if (degrees == 90 || degrees == 270) {
                canvas.width = image.naturalHeight;
                canvas.height = image.naturalWidth;
            } else {
                canvas.width = image.naturalWidth;
                canvas.height = image.naturalHeight;
            }

            context.clearRect(0, 0, canvas.width, canvas.height);

            if (degrees == 90 || degrees == 270) {
                context.translate(image.naturalHeight / 2, image.naturalWidth / 2);
            } else {
                context.translate(image.naturalWidth / 2, image.naturalHeight / 2);
            }

            context.rotate(degrees * Math.PI / 180);
            context.drawImage(image, -image.naturalWidth / 2, -image.naturalHeight / 2);

            return canvas;
        }

        function cropImage(img, canvas, x, y, w, h) {
            var context = canvas.getContext('2d');

            canvas.setAttribute('width', w);
            canvas.setAttribute('height', h);
            context.drawImage(img, x, y, w, h, 0, 0, w, h);

            return canvas.toDataURL();
        }

        var calculateAnimationTargetValues = function (originalHeight, originalWidth, currentHeight, currentWidth, maxWidth, max_height) {
            var aspectRatioForHeight = originalHeight / originalWidth;
            var aspectRatioForWidth = originalWidth / originalHeight;
            var scaleFactor = aspectRatioForWidth;
            var targetWidth, targetHeight, newCenter, rotation;

            if (originalHeight > originalWidth) {
                rotation = "portrait to landscape";

                targetHeight = currentWidth * aspectRatioForHeight;

                // fit to max image height
                if (targetHeight > originalHeight) {
                    targetHeight = originalHeight;
                }

                targetWidth = targetHeight * aspectRatioForWidth;

                // fit to max slot width
                if (targetHeight > maxWidth) {
                    targetHeight = maxWidth;
                    targetWidth = targetHeight * aspectRatioForWidth;
                }

                newCenter = (currentHeight - targetWidth) * -0.5;

                if (targetWidth * scaleFactor < originalWidth && originalWidth < maxWidth) {
                    scaleFactor = originalWidth / targetWidth;

                    if (currentHeight * scaleFactor != targetHeight) {
                        scaleFactor = targetHeight / currentHeight;
                    }
                }
            } else {
                rotation = "landscape to portrait";

                targetHeight = originalHeight * currentWidth / originalHeight;
                targetWidth = targetHeight * aspectRatioForHeight;

                if (targetWidth < maxWidth) {
                    // fit to slot width
                    if (originalWidth > maxWidth) {
                        targetWidth = maxWidth;
                        targetHeight = targetWidth * aspectRatioForWidth;

                        if (targetHeight > originalWidth) {
                            targetHeight = originalWidth;
                            targetWidth = targetHeight * aspectRatioForHeight;
                        }
                    } else {
                        // fit to max image width
                        targetWidth = originalWidth;
                        targetHeight = targetWidth * aspectRatioForWidth;

                        // if calculated height is too high
                        if (targetHeight > originalWidth) {
                            targetHeight = originalWidth;
                            targetWidth = targetHeight * aspectRatioForHeight;
                        }
                    }
                }

                if (targetWidth > maxWidth) {
                    // todo: this should never happen, try to reproduce this case
                    targetWidth = maxWidth;
                    targetHeight = targetWidth * aspectRatioForHeight;
                }

                newCenter = ((currentHeight/2) - (targetHeight/2)) * -1;

                // is scaleFactor too high?
                if (targetHeight * scaleFactor > originalWidth) {
                    scaleFactor = originalHeight / targetWidth;

                    // too low?
                    if (currentHeight * scaleFactor != targetWidth) {
                        scaleFactor = targetWidth / currentHeight;
                    }
                }
            }

            return {
                rotation: rotation,
                target_height: targetHeight,
                target_width: targetWidth,
                scale_factor: scaleFactor,
                new_center: newCenter
            };
        };

        var inProgress;
        var animationTimeInMs = 600; // not lower than {timeForAngularToRenderImageInMs} please

        function rotateImageAnimation(direction) {
            if (inProgress) {
                return;
            }

            inProgress = true;

            // this is our original image object
            var subject = document.getElementById('image');
            var slot = s.editing.findParentWithClass(subject, 'slot');
            var fileUpdateWrap = s.editing.findParentWithClass(subject, 'file-upload-wrap');
            var figure = s.editing.findParentWithTag(subject, 'figure');

            // todo: find a better solution: to use -90 instead of 270 we need to fix rotation inside the canvas and the animation
            var deg = direction == 'right' ? 90 : 270;

            var timeAfterAngularStartsRenderingInMs = 100;
            var transitionDurationInS = (animationTimeInMs - timeAfterAngularStartsRenderingInMs) / 1000;

            // definition of transition timing
            fileUpdateWrap.style.transition = 'height ' + (transitionDurationInS / 3) + 's';
            subject.style.transition = 'transform ' + transitionDurationInS + 's';

            // here we reset all styles & attrs changed/added during rotation after the rotated image
            // from canvas is applied to the image tag (subject)
            subject.onload = function () {
                subject.onload = null;
                subject.style.transition = '';
                subject.style.transform = '';

                subject.style.opacity = '1';

                fileUpdateWrap.style.transition = '';
                fileUpdateWrap.style.height = '';
            };

            // set height to ensure that transition is working (xpx > ypx vs. auto > ypx)
            fileUpdateWrap.style.height = fileUpdateWrap.getBoundingClientRect().height + 'px';
            // looks nice but causes performance issues on tablet
            //fileUpdateWrap.style.overflow = 'hidden';

            var roatedImagesInsideCanvas = rotateImage(deg);
            var originalImage = new Image();
            var dataUrl = roatedImagesInsideCanvas.toDataURL();

            originalImage.src = dataUrl;
            originalImage.onload = function () {
                var values = calculateAnimationTargetValues(
                    originalImage.width, originalImage.height, // sizes of original image
                    subject.height, subject.width, // sizes of rendered image
                    figure.getBoundingClientRect().width, // max width of slot
                    999999 // max height of slot (= infinite)
                );

                if (values.rotation == 'landscape to portrait') {
                    fileUpdateWrap.style.height = values.target_height + 'px';
                } else {
                    fileUpdateWrap.style.height = values.target_width + 'px';
                }

                if (deg == 270) {
                    deg = -90;
                }

                subject.style.transform = 'translateY(' + values.new_center + 'px) scale(' + values.scale_factor + ') rotate(' + deg + 'deg)';
                subject.style.opacity = '1';

                setTimeout(function () {
                    // comment in for debugging purposes
                    //subject.onclick = function () {
                    subject.style.opacity = '0';
                    s.slot.content = dataUrl;
                    sendFile(dataUrl);
                    s.$digest();
                    //};

                    // give angular time to execute $apply()
                    setTimeout(function () {
                        inProgress = false;
                    }, timeAfterAngularStartsRenderingInMs / 2);
                }, animationTimeInMs - (timeAfterAngularStartsRenderingInMs / 2));
            };
        }


    return {
        restrict: 'E',
        scope: true,
        link: function ($scope, element, attrs) {
            $scope.getDisplayImage = function () {
                if ($scope.slot.settings && $scope.slot.settings.queue_id) {
                    return UploadQueue.getImage($scope.slot.settings.queue_id);
                } else {
                    return $scope.slot.content;
                }
            };

            $scope.mx = {
                aspectRatio: null,
                displayWidth: null,
                displayHeight: null,
                scaledWidth: null,
                scaledHeight: null,
                scaledTop: null,
                scaledLeft: null,
                imgLoader: null,
                imgSrc: null
            };

            var cropOption = {
                label: 'Zuschneiden',
                icon: 'crop',
                callback: function() {
                    $scope.mode.crop = true;
                }
            };

            var rotateLeftOption = {
                label: 'Links drehen',
                icon: 'rotate_left',
                shortcut: 'left',
                callback: function () {
                    rotateImageAnimation('left');
                }
            };

            var rotateRightOption = {
                label: 'Rechts drehen',
                icon: 'rotate_right',
                shortcut: 'right',
                callback: function () {
                    rotateImageAnimation('right');
                }
            };

            var confirmCropOption = {
                label: 'Ausgewählten Bereich zuschneiden',
                icon: 'done',
                callback: function () {
                    var img = $window.document.getElementById('imageCropSource');
                    var canvas = $window.document.getElementById('canvas');

                    var
                        x = s.mx.scaledLeft,
                        y = s.mx.scaledTop,
                        w = s.mx.scaledWidth,
                        h = s.mx.scaledHeight;

                    var dataURL = cropImage(img, canvas, x, y, w, h);
                    updatePreview((dataURL));
                    sendFile(dataURL);

                    $scope.mode.crop = false;

                    messages.notify('image-crop-confirm');
                }
            };

            var cancelCropOption = {
                label: 'Abbrechen',
                icon: 'clear',
                callback: function() {
                    $scope.mode.crop = false;
                }
            };

            $scope.mode.crop = false;
            $scope.slot.uploading = false;

            if ($window.File && $window.FileReader && $window.FormData) {
                $scope.$watch('slot.edit', function (inEditMode) {

                    /** @type {msSlot} */
                    var slot = $scope.slot;

                    if (inEditMode) {
                        $scope.$watch('mode.crop', function (cropModeEnabled, cropModeOld) {
                            if (cropModeEnabled) {
                                messages.show('image-slot-crop');
                                $scope.$parent.editing.slot_options = [confirmCropOption, cancelCropOption];
                            } else {
                                if (cropModeOld) messages.hide(); // hide only if it was enabled...

                                // enable slot options
                                $scope.$watch('slot.uploading', function (isUploading) {
                                    if (isUploading) { // disable slot options during upload
                                        $scope.$parent.editing.slot_options = [];
                                    } else if (slot.edit) { // prevent showing options if slot is no longer active
                                        $scope.$parent.editing.slot_options = [cropOption, rotateLeftOption, rotateRightOption];
                                    }
                                });

                                s = $scope;

                                setTimeout(function() {
                                    var fileInput = document.getElementById('file');
                                    if (!fileInput) return; // TODO

                                    fileInput.onchange = function (e) {
                                        var file = e.target.files[0];

                                        if (file) {
                                            if (/^image\//i.test(file.type)) {
                                                readFile(file);
                                            } else {
                                                // todo: handle error console.log('Not a valid image!'); // TODO
                                            }
                                        } else {
                                            // todo: hanlde error console.log('No file!');
                                        }
                                    };
                                }, 50);
                            }
                        });
                    }
                });

            } else {
                // file upload not supported
            }
        },
        template: $templateCache.get('slots/image/image.html')
    };
}]);

image.directive('imageCrop', ['$templateCache', function ($templateCache) {
    return {
        restrict: 'A',
        template: $templateCache.get('slots/image/image-crop.html'),
        scope: {
            aspectRatio: '=?',
            displayWidth: '=?',
            displayHeight: '=?',
            scaledWidth: '=?',
            scaledHeight: '=?',
            scaledTop: '=?',
            scaledLeft: '=?',
            imgLoader: '=?',
            imgSrc: '='
        },
        controller: ['$scope', '$element', '$window', function ($scope, $element, $window) {

            // Representation of Crop DIV.
            var rectangleLeft;
            var rectangleRight;
            var rectangleTop;
            var rectangleWidth;
            var rectangleHeight;
            var focusedOnCrop = false;

            // DOM For Manipulatable Elements.
            var imageCropSelectorDiv = $window.document.getElementById("imageCropSelector");
            var imageTag; // Any interaction with this should verify that the elemented has loaded.

            // Translation
            var draggingRectangle = false;
            var originalDragX = 0;
            var originalDragY = 0;
            var dragCorrectionX = 0;
            var dragCorrectionY = 0;

            // Resizing
            var resizingRectangle = false;
            var startResizeMouseX = 0;
            var startResizeMouseY = 0;
            var currentResizeOrigin = 0;

            // Rectangle 'Creation'
            var originalMouseX = 0;
            var originalMouseY = 0;

            var mouseXRelative = 0;
            var mouseYRelative = 0;

            // Account for possible scrolling.
            var scrollLeft = 0;
            var scrollTop = 0;

            // Optional pass of aspect ratio.
            if ($scope.aspectRatio) {
                var ratioValues = $scope.aspectRatio.split("/");
                var aspectRatioX = ratioValues[0];
                var aspectRatioY = ratioValues[1];
            }

            $scope.$watch("aspectRatio", function (newValue, oldValue) {
                if (newValue) {
                    if (newValue !== oldValue && newValue.split("/").length == 2) {
                        var ratioValues = newValue.split("/");
                        aspectRatioX = ratioValues[0];
                        aspectRatioY = ratioValues[1];

                        horizontalScaling(0, 0, 0);

                        // If we don't perform this check, and we go from false, to true aspectRatio,
                        // a "0x0" rectangle will draw, and set the background to black.
                        if (rectangleLeft || rectangleRight || rectangleRight || rectangleHeight) {
                            drawRectangle(true);
                        }
                    }
                    // todo: handle error console.log('File support!');
                }
            });

            // We have to load the original image in order to get it
            $scope.originalImageWidth = 0;
            $scope.originalImageHeight = 0;


            // We need to make sure the image has loaded before we try and get the height.
            $element[0].children[0].onload = function () {
                $window.document.getElementById("cropToolLoading").style.display = "none";
                imageTag = $window.document.getElementById("imageCropSource");
                $scope.currentImageWidth = imageTag.offsetWidth;
                $scope.currentImageHeight = imageTag.offsetHeight;

                // Load the original image again (from the cache), so we can see what the original size is.
                var originalImage = new Image();

                originalImage.onload = function () {
                    $scope.originalImageWidth = this.width;
                    $scope.originalImageHeight = this.height;

                    $scope.scaleFactor = this.width / imageTag.offsetWidth;
                };

                originalImage.src = imageTag.src;
            };


            var mouseModifyingRectangle = false;
            var currentResizingFunc;

            // Moved these to function calls because there is logic based on whether there is any scroll active or not
            var calculateMouseXRelative = function (e) {
                if (scrollLeft) {
                    mouseXRelative = e.pageX - offset.left - scrollLeft;
                } else {
                    mouseXRelative = e.pageX - offset.left;
                }
            };

            var calculateMouseYRelative = function (e) {
                if (scrollTop) {
                    mouseYRelative = e.pageY - offset.top - scrollTop;
                } else {
                    mouseYRelative = e.pageY - offset.top;
                }
            };

            var resetBackgroundColor = function () {
                imageCropSelectorDiv.style.display = "none";
                $element[0].children[2].style.backgroundColor = "transparent";
            };

            var selectedBackgroundColor = function () {
                imageCropSelectorDiv.style.display = "block";
                $element[0].children[2].style.backgroundColor = "rgba(0,0,0,0.3)";
            };

            var horizontalScaling = function (xDelta, yDelta, origin) {
                if (origin === 0) { // Left
                    rectangleWidth += xDelta;
                    rectangleLeft -= xDelta;
                } else { // Right
                    rectangleWidth -= xDelta;
                }

                if (rectangleWidth < 0) {
                    rectangleWidth = 0;
                }


                if (rectangleLeft < 0) {
                    rectangleLeft = 0;
                }

                if (rectangleWidth + rectangleLeft > imageTag.offsetWidth) {
                    rectangleWidth = imageTag.offsetWidth - rectangleLeft;
                }


                if ($scope.aspectRatio) {

                    if (rectangleWidth * (aspectRatioY / aspectRatioX) + rectangleTop > imageTag.offsetHeight) {
                        rectangleWidth = (imageTag.offsetHeight - rectangleTop) / (aspectRatioY / aspectRatioX);
                    }

                    rectangleHeight = rectangleWidth * (aspectRatioY / aspectRatioX);
                }

            };

            var verticalScaling = function (xDelta, yDelta, origin) {
                if (origin === 0) { // Top
                    rectangleHeight += yDelta;
                    rectangleTop -= yDelta;
                } else { // Bottom
                    rectangleHeight -= yDelta;
                }

                if (rectangleHeight < 0) {
                    rectangleHeight = 0;
                }

                // Make sure the div doesn't break out of its container.
                if (rectangleTop < 0) {
                    rectangleTop = 0;
                }

                if (rectangleHeight + rectangleTop > imageTag.offsetHeight) {
                    rectangleHeight = imageTag.offsetHeight - rectangleTop;
                }


                // Make sure that we maintain our ratio
                if ($scope.aspectRatio) {
                    if (rectangleHeight * (aspectRatioX / aspectRatioY) + rectangleLeft > imageTag.offsetWidth) {
                        rectangleHeight = (imageTag.offsetHeight - rectangleLeft) / (aspectRatioX / aspectRatioY);
                    }

                    rectangleWidth = rectangleHeight * (aspectRatioX / aspectRatioY);
                }
            };


            // Origin starts at top-left and rotates clockwise.
            var diagonalScaling = function (xDelta, yDelta, origin) {
                if (origin === 0) { // Top-left
                    horizontalScaling(xDelta, yDelta, 0);
                    verticalScaling(xDelta, yDelta, 0);
                } else if (origin === 1) { // Top-right
                    verticalScaling(xDelta, yDelta, 0);

                    if (!$scope.aspectRatio) {
                        horizontalScaling(xDelta, yDelta, 1);
                    }
                } else if (origin === 2) { // Bottom-right
                    verticalScaling(xDelta, yDelta, 1);

                    if (!$scope.aspectRatio) {
                        horizontalScaling(xDelta, yDelta, 1);
                    }
                } else if (origin === 3) { // Bottom-left
                    horizontalScaling(xDelta, yDelta, 0);

                    if (!$scope.aspectRatio) {
                        verticalScaling(xDelta, yDelta, 1);
                    }
                }

                drawRectangle();
            };

            var translate = function (xDelta, yDelta) {
                if (rectangleLeft - xDelta > 0 && rectangleLeft - xDelta + rectangleWidth < imageTag.offsetWidth) {
                    rectangleLeft -= xDelta;
                } else if (rectangleLeft - xDelta < 0) {
                    rectangleLeft = 0;
                } else if (rectangleLeft - xDelta + rectangleWidth > imageTag.offsetWidth) {
                    rectangleLeft = imageTag.offsetWidth - rectangleWidth;
                }

                if (rectangleTop - yDelta > 0 && rectangleTop - yDelta + rectangleHeight < imageTag.offsetHeight) {
                    rectangleTop -= yDelta;
                } else if (rectangleTop - yDelta < 0) {
                    rectangleTop = 0;
                } else if (rectangleTop - yDelta + rectangleHeight > imageTag.offsetHeight) {
                    rectangleTop = imageTag.offsetHeight - rectangleHeight;
                }
            };

            function resetInteractions() {
                draggingRectangle = false;
                mouseModifyingRectangle = false;
            }

            function calculateRectangleDimensions(mouseX, mouseY, oldMouseX, oldMouseY) {
                var tempHolder;

                if (mouseX < oldMouseX) {
                    tempHolder = mouseX;
                    mouseX = oldMouseX;
                    oldMouseX = tempHolder;
                }

                if (mouseY < oldMouseY) {
                    tempHolder = mouseY;
                    mouseY = oldMouseY;
                    oldMouseY = tempHolder;
                }

                var width = mouseX - oldMouseX;

                // Figure out if enforcing the aspect ratio any further than we already have would
                // break the crop out of the parent div.
                if ($scope.aspectRatio) {
                    if (width * (aspectRatioY / aspectRatioX) + oldMouseY > imageTag.offsetHeight) {
                        width = (imageTag.offsetHeight - oldMouseY) / (aspectRatioY / aspectRatioX);
                    }
                }

                var height;

                if ($scope.aspectRatio) {
                    height = width * (aspectRatioY / aspectRatioX);
                } else {
                    height = mouseY - oldMouseY;
                }


                oldMouseY += dragCorrectionY;
                oldMouseX += dragCorrectionX;


                if (oldMouseX + width > imageTag.offsetWidth) {
                    oldMouseX = imageTag.offsetWidth - width;
                }

                if (oldMouseY + height > imageTag.offsetHeight) {
                    oldMouseY = imageTag.offsetHeight - height;
                }

                // Prevent crop-box from leaving the boundaries of the div. Snap
                // to the closest edge if outside of element.
                if (oldMouseX < 0) {
                    oldMouseX = 0;
                    dragCorrectionX = 0;
                }

                if (oldMouseY < 0) {
                    oldMouseY = 0;
                    dragCorrectionY = 0;
                }

                rectangleLeft = oldMouseX;
                rectangleTop = oldMouseY;
                rectangleWidth = width;
                rectangleHeight = height;
            }


            var onMouseUpFunction = function (e) {
                originalDragX = 0;
                originalDragY = 0;
                e.preventDefault();
                resetInteractions();

                if (resizingRectangle) {
                    stopResizing(e);
                }
            };

            var onScrollFunction = function (e) {
                scrollLeft = ($window.pageXOffset || $window.document.scrollLeft) - ($window.clientLeft || 0);
                scrollTop = ($window.pageYOffset || $window.window.scrollTop) - ($window.clientTop || 0);
            };

            function drawRectangle(calledInsideAngular) {
                // Move the correct part of the background image into the view/
                imageCropSelectorDiv.style.backgroundPosition = "-" + (rectangleLeft + 1) + "px" + " -" + (rectangleTop + 1) + "px";
                imageCropSelectorDiv.style.backgroundSize = imageTag.offsetWidth + "px";

                // Set the top and left position of the div.
                imageCropSelectorDiv.style.left = rectangleLeft + "px";
                imageCropSelectorDiv.style.top = rectangleTop + "px";

                // Set Div Height and Width
                imageCropSelectorDiv.style.width = rectangleWidth + "px";
                imageCropSelectorDiv.style.height = rectangleHeight + "px";

                selectedBackgroundColor();

                $scope.displayHeight = Math.round(rectangleHeight);
                $scope.displayWidth = Math.round(rectangleWidth);
                $scope.scaledHeight = Math.round(rectangleHeight * $scope.scaleFactor);
                $scope.scaledWidth = Math.round(rectangleWidth * $scope.scaleFactor);
                $scope.scaledLeft = Math.round(rectangleLeft * $scope.scaleFactor);
                $scope.scaledTop = Math.round(rectangleTop * $scope.scaleFactor);

                if (!calledInsideAngular) {
                    $scope.$parent.$digest();
                }
            }

            function startTranslation(e) {
                e.preventDefault();
                e.stopPropagation();
                draggingRectangle = true;
                originalDragX = e.pageX;
                originalDragY = e.pageY;
            }

            function midTranslation(e) {
                var newDragX = e.pageX;
                var newDragY = e.pageY;
                translate(originalDragX - newDragX, originalDragY - newDragY);
                originalDragX = newDragX;
                originalDragY = newDragY;
                drawRectangle();
            }

            function stopTranslation(e) {
                resizingRectangle = false;
            }

            function stopResizing(e) {
                resizingRectangle = false;
            }

            function midResizing(e) {
                e.preventDefault();
                e.stopPropagation();
                var currentResizeMouseX = e.pageX;
                var currentResizeMouseY = e.pageY;
                currentResizingFunc(startResizeMouseX - currentResizeMouseX, startResizeMouseY - currentResizeMouseY, currentResizeOrigin);
                startResizeMouseX = currentResizeMouseX;
                startResizeMouseY = currentResizeMouseY;
                drawRectangle();
            }

            function startResizing(e, origin, resizeFunction) {
                e.preventDefault();
                e.stopPropagation();
                startResizeMouseX = e.pageX;
                startResizeMouseY = e.pageY;

                resizingRectangle = true;
                currentResizeOrigin = origin;
                currentResizingFunc = resizeFunction;
            }

            var offset;

            var x = $element[0].children[2];

            // Instantiate crop rectangle.
            var rectangleDown = function (e) {
                e.preventDefault();
                mouseModifyingRectangle = true;
                focusedOnCrop = true;

                // All coordinates are relative to the parent container
                offset = this.getBoundingClientRect();
                if (scrollLeft) {
                    originalMouseX = e.pageX - offset.left - scrollLeft;
                } else {
                    originalMouseX = e.pageX - offset.left;
                }

                if (scrollTop) {
                    originalMouseY = e.pageY - offset.top - scrollTop;
                } else {
                    originalMouseY = e.pageY - offset.top;
                }
            };
            x.addEventListener("mousedown", rectangleDown);
            x.addEventListener("touchstart", rectangleDown);

            // Move the crop rectangle.
            var rectangleMove = function (e) {
                if (draggingRectangle) {
                    midTranslation(e);
                }
                if (mouseModifyingRectangle) {
                    offset = this.getBoundingClientRect();
                    calculateMouseXRelative(e);
                    calculateMouseYRelative(e);

                    dragCorrectionX = 0;
                    dragCorrectionY = 0;
                    calculateRectangleDimensions(mouseXRelative, mouseYRelative, originalMouseX, originalMouseY);
                    drawRectangle();
                }

                if (resizingRectangle) {
                    midResizing(e);
                }
            };
            x.addEventListener("mousemove", rectangleMove);
            x.addEventListener("touchmove", rectangleMove);

            x.addEventListener("mouseup", function (e) { resetInteractions(); });
            x.addEventListener("touchend", function (e) { resetInteractions(); });


            // Instantiate translate event.
            var selectorDivMoveDown = function (e) {
                startTranslation(e);
                focusedOnCrop = true;
            };
            imageCropSelectorDiv.addEventListener("mousedown", selectorDivMoveDown);
            imageCropSelectorDiv.addEventListener("touchstart", selectorDivMoveDown);

            var selectorDivMove = function (e) {
                e.preventDefault();
                if (mouseModifyingRectangle) {
                    offset = $element[0].children[2].getBoundingClientRect();
                    calculateMouseXRelative(e);
                    calculateMouseYRelative(e);

                    calculateRectangleDimensions(mouseXRelative, mouseYRelative, originalMouseX, originalMouseY);
                    drawRectangle();
                }

                if (draggingRectangle) {
                    midTranslation(e);
                }

                if (resizingRectangle) {
                    midResizing(e);
                }
            };
            imageCropSelectorDiv.addEventListener("mousemove", selectorDivMove);
            imageCropSelectorDiv.addEventListener("touchmove", selectorDivMove);

            var selectorDivUp = function (e) {
                originalDragX = 0;
                originalDragY = 0;
                e.preventDefault();
                resetInteractions();
            };
            imageCropSelectorDiv.addEventListener("mouseup", selectorDivUp);
            imageCropSelectorDiv.addEventListener("touchend", selectorDivUp);

            angular.element($window).on('mouseup', onMouseUpFunction);
            angular.element($window).on('touchend', onMouseUpFunction);

            $scope.$on("$destroy", function () {
                angular.element($window).off('scroll', onMouseUpFunction);
            });

            angular.element($window).on('scroll', onScrollFunction);
            $scope.$on("$destroy", function () {
                angular.element($window).off('scroll', onScrollFunction);
            });


            x.addEventListener("mouseout", function (e) {
                if (mouseModifyingRectangle) {
                    offset = this.getBoundingClientRect();
                    calculateMouseXRelative(e);

                    if (mouseXRelative > $scope.currentImageWidth) {
                        mouseXRelative = $element[0].children[0].offsetWidth;
                    } else if (mouseXRelative < 0) {
                        mouseXRelative = 0;
                    }
                    calculateMouseYRelative(e);

                    if (mouseYRelative < 0) {
                        mouseYRelative = 0;
                    }

                    calculateRectangleDimensions(mouseXRelative, mouseYRelative, originalMouseX, originalMouseY);
                    drawRectangle();
                }
            });
            x.addEventListener("touchend", function (e) {
                if (mouseModifyingRectangle) {
                    offset = this.getBoundingClientRect();
                    calculateMouseXRelative(e);

                    if (mouseXRelative > $scope.currentImageWidth) {
                        mouseXRelative = $element[0].children[0].offsetWidth;
                    } else if (mouseXRelative < 0) {
                        mouseXRelative = 0;
                    }
                    calculateMouseYRelative(e);

                    if (mouseYRelative < 0) {
                        mouseYRelative = 0;
                    }

                    calculateRectangleDimensions(mouseXRelative, mouseYRelative, originalMouseX, originalMouseY);
                    drawRectangle();
                }
            });

            x.addEventListener("click", function (e) {
                if (!draggingRectangle && !resizingRectangle && !mouseModifyingRectangle) {
                    resetBackgroundColor();
                }
            });

            var dragListener = {
                // Diagonal Scaling - Blagh.
                "resize_top_left": function (e) { startResizing(e, 0, diagonalScaling); },
                "resize_top_right": function (e) { startResizing(e, 1, diagonalScaling); },
                "resize_bottom_right": function (e) { startResizing(e, 2, diagonalScaling); },
                "resize_bottom_left": function (e) { startResizing(e, 3, diagonalScaling); },

                // Horizontal Scaling. Yay!
                "resize_middle_left": function (e) { startResizing(e, 0, horizontalScaling); },
                "resize_left": function (e) { startResizing(e, 0, horizontalScaling); },
                "resize_middle_right": function (e) { startResizing(e, 1, horizontalScaling); },
                "resize_right": function (e) { startResizing(e, 1, horizontalScaling); },

                // Vertical Scaling. Yay!
                "resize_top_middle": function (e) { startResizing(e, 0, verticalScaling); },
                "resize_top": function (e) { startResizing(e, 0, verticalScaling); },
                "resize_bottom_middle": function (e) { startResizing(e, 1, verticalScaling); },
                "resize_bottom": function (e) { startResizing(e, 1, verticalScaling); }
            };

            for (var id in dragListener) {
                if (dragListener.hasOwnProperty(id)) {
                    $window.document.getElementById(id).addEventListener("mousedown", dragListener[id]);
                    $window.document.getElementById(id).addEventListener("touchstart", dragListener[id]);
                }
            }
        }]
    };
}]);

